import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import classNames from 'classnames';
import copy from 'copy-to-clipboard';
import { addAll, saveList, loadList, changeGame } from '../../actions/versionActions';
import { createJSONData, parseJSONData } from '../../utils/json-data-util';
import isPrivateSite from '../../utils/is-private-site-util';
import versionCountStore from '../../stores/versionCountStore';
import roleStore from '../../stores/rolesStore';
import ActionBarMenu from './ActionBarMenu';
import PrintExport from '../PrintExport';
import { defaultConfig } from '../../constants/version-config';

// used for testing pdf export -- it is not included in production builds
import { dummyData, dummyScriptAuthor, dummyScriptTitle } from '../../../../example_data/pdfExportDummyData';

const pulsateAnimation = keyframes`
  0% { background-size: 20px; }
  100% { background-size: 30px; }
`;

const ActionBarItem = css`
background-image: url("${props => props.iconImgSrc}");
width: 48px;
height: 48px;
background-repeat: no-repeat;
background-position: center center;
background-color: ${props => props.overrideBGColour || '#fff'};
border-radius: 50%;
border: none;
box-shadow: 1px 1px 6px #0000002f;
cursor: ${props => props['data-tip-disable'] ? 'not-allowed' : 'pointer'};
opacity: ${props => props['data-tip-disable'] ? '0.5' : '1'};

animation: ${props => props.doPulsate ? `${pulsateAnimation} 0.5s infinite alternate` : 'none'};
`;

const ActionBarItemAnchor = styled.a`
${ActionBarItem}
`;

const ActionBarItemButton = styled.button`
${ActionBarItem}
`;

const ActionBarBottomButtons = styled.div`
margin-top: auto;
display: flex;
flex-direction: column;
gap: 16px;
`;

const fadeAnimation = keyframes`
  0% { opacity: 0; }
  5% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; }
`;

const ClipboardCopyNotification = styled.div`
  opacity: 0;
  animation: ${fadeAnimation} 3s;
  position: fixed;
  top: 10px;
  left: 50%;
  width: 200px;
  margin-left: -100px;
  background-color: black;
  padding: 15px;
  text-align: center;
`;

class ActionBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExporting: false,
      isLetterExportFormat: false,
      isImageFormat: false,
      didClipboardCopySucceed: false,
      showClipboardCopyNotification: false,
      showExportUI: false,
    };

    this.setGame = this.setGame.bind(this);
    this.exportPrint = this.exportPrint.bind(this);
    this.copyList = this.copyList.bind(this);
    this.saveList = this.saveList.bind(this);
    this.loadList = this.loadList.bind(this);
    this.openFileDialog = this.openFileDialog.bind(this);

    this.clipboardCopyNotifTimeoutID = null;
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({isExporting: props.isExporting});
  }

  setGame(gameName) {
    changeGame(gameName);
  }

  exportPrint(isLetterFormat, isImageFormat) {
    this.setState({ showExportUI: true, isLetterExportFormat: isLetterFormat, isImageFormat: isImageFormat });
  }

  saveList() { saveList(this.props.scriptName, this.props.scriptAuthor); }

  copyList() {
    clearTimeout(this.clipboardCopyNotifTimeoutID);

    this.setState({ showClipboardCopyNotification: false }, () => { // this initial set state is to kill the current notification if exists
      this.setState(
        {
          didClipboardCopySucceed: copy(JSON.stringify(createJSONData(this.props.versionList, this.props.scriptAuthor, this.props.scriptName))),
          showClipboardCopyNotification: true,
        },
        () => {
          this.clipboardCopyNotifTimeoutID = setTimeout(() => {
            this.setState({ showClipboardCopyNotification: false });
          }, 5000);
        });
    });
  }

  loadList(e) {
    const file = e.target.files[0];
    const reader = new FileReader();
    const roleList = roleStore.getRoles();
    const thisObj = this;

    reader.onload = function(event) {
      try {
        const parsedData = parseJSONData(event.target.result, roleList);

        if (parsedData) {
          loadList(parsedData.list, null);

          document.getElementById("fileLoader").value = '';
          thisObj.props.changeScriptName(parsedData.metadata.name ? parsedData.metadata.name : file.name.split('.')[0]);
          thisObj.props.changeScriptAuthor(parsedData.metadata.author);
        }
        else alert('The provided file was not in the correct format. No data has been loaded.');
      }
      catch(e) { alert('There was a problem trying to load your file. Please try again!'); }
    };

    reader.readAsText(file);
  }

  openFileDialog() { document.getElementById("fileLoader").click(); }


  renderCopyToClipboardButton() {

    if (!isPrivateSite()) return null;

    return <div>
      <button
        onClick={() => {this.copyList()}}
        type="button"
        className={classNames("action-bar__copy-button")}
      >
        Copy to Clipboard
      </button>
    </div>
  }

  render() {
    const isDefaultGameType = !this.props.gameType || this.props.gameType == defaultConfig.type;

    return <div className={classNames(
      "main__action-bar",
      {"main__action-bar--collapsed": !this.props.isActionBarExpanded}
    )}>
        {this.state.showExportUI &&
          <PrintExport
            scriptAuthor={this.props.scriptAuthor}
            scriptName={this.props.scriptName}
            isExporting={this.state.isExporting}
            isLetterExportFormat={this.state.isLetterExportFormat}
            isImageFormat={this.state.isImageFormat}
            handleCloseClick={() => { this.setState({ showExportUI: false })}}
          />
        }

        {this.state.showClipboardCopyNotification && <ClipboardCopyNotification>{this.state.didClipboardCopySucceed ? 'Copied to clipboard!' : 'Unable to copy to clipboard'}</ClipboardCopyNotification>}

        {
          process.env.NODE_ENV == 'development'
            && <div style={{ color: 'black', position: 'absolute', top: 0, right: '120px', width: '140px', fontSize: '9pt', display: 'flex', 'flexDirection': 'column' }}>
              <button onClick={() => { addAll(dummyData); this.props.changeScriptName(dummyScriptTitle); this.props.changeScriptAuthor(dummyScriptAuthor); this.exportPrint(false, true) }}>export TEST A4 image</button>
              <button onClick={() => { addAll(dummyData); this.props.changeScriptName(dummyScriptTitle); this.props.changeScriptAuthor(dummyScriptAuthor); this.exportPrint(true, true) }}>export TEST letter image</button>
              <button onClick={() => { addAll(dummyData); this.props.changeScriptName(dummyScriptTitle); this.props.changeScriptAuthor(dummyScriptAuthor); this.exportPrint(false, false) }}>export TEST A4 pdf</button>
              <button onClick={() => { addAll(dummyData); this.props.changeScriptName(dummyScriptTitle); this.props.changeScriptAuthor(dummyScriptAuthor); this.exportPrint(true, false) }}>export TEST letter pdf</button>
            </div>
        }

        <ActionBarItemButton
          iconImgSrc={`./images/website/icon-users${isDefaultGameType ? '' : '-light'}.svg`}
          overrideBGColour={!isDefaultGameType && '#411F5C'}
          data-for="actionBarUserMenu"
          data-event="click"
          data-tip-disable={this.state.isExporting}
          data-tip
          title="Players"
        />
        <ActionBarMenu
          id="actionBarUserMenu"
          title="Players"
          iconImgSrc="./images/website/icon-users.svg"
          selectedItem={this.props.gameType}
          itemData={[
            {label: 'Ravenswood Bluff (13/4/4/4)', id: 'standard', onClick: this.setGame},
            {label: 'Teensyville (6/2/2/2)', id: 'teensy', onClick: this.setGame},
            {label: 'Phobos (Any)', id: 'any', onClick: this.setGame},
          ]}
          alignTopHack={true}
        />

        <ActionBarItemButton
          iconImgSrc="./images/website/icon-save.svg"
          doPulsate={this.state.isExporting}
          data-for="actionBarSaveMenu"
          data-event="click"
          data-tip-disable={(versionCountStore.getTotal() === 0 || this.state.isExporting)}
          data-tip
          title="Save/Export"
        />
        <ActionBarMenu
          id="actionBarSaveMenu"
          title="Save"
          iconImgSrc="./images/website/icon-save.svg"
          selectedItem={null}
          itemData={[
            {label: 'To Clipboard', onClick: this.copyList},
            {label: 'Download JSON', onClick: this.saveList},
            {label: 'PDF (letter)', onClick: () => { this.exportPrint(true) }},
            {label: 'PDF (A4)', onClick: () => { this.exportPrint(false) }},
            {label: 'PNG (letter)', onClick: () => { this.exportPrint(true, true) }},
            {label: 'PNG (A4)', onClick: () => { this.exportPrint(false, true) }},
          ]}
          isDisabled={this.state.isExporting}
        />

        <ActionBarItemButton
          data-tip-disable={this.state.isExporting}
          iconImgSrc="./images/website/icon-upload.svg"
          onClick={this.openFileDialog}
          title="Import (JSON)"
        />
        <input
          onChange={this.loadList}
          style={{display:"none"}}
          type="file"
          id="fileLoader"
          name="files"
          title="Load File"
          accept=".json"
        />

        <ActionBarItemAnchor
          iconImgSrc="./images/website/icon-cart.svg"
          overrideBGColour="#411F5C"
          title="Buy"
          href="https://bloodontheclocktower.com/products/blood-on-the-clocktower-the-game"
        />

      <ActionBarBottomButtons>
        {/* <ActionBarItem
          iconImgSrc="./images/website/icon-info.svg"
          onClick={this.props.onInfoClick}
        /> */}
        <ActionBarItemButton
          iconImgSrc="./images/website/icon-zoom-in.svg"
          isOn={this.props.isZoomed}
          onClick={this.props.onZoomToggle}
          title="Zoom toggle"
        />
      </ActionBarBottomButtons>
    </div>
  }
}

ActionBar.propTypes = {
  isActionBarExpanded: PropTypes.bool,
  versionList: PropTypes.array,
  isZoomed: PropTypes.bool,
  onZoomToggle: PropTypes.func,
  onInfoClick: PropTypes.func,
  gameType: PropTypes.string,
};

export default ActionBar;
